export default __webpack_public_path__ + "static/icons-fdaf232a226744f89aa9dd1945f0aec7.svg";